import React from 'react';
import PropTypes from 'prop-types';
import PortfolioShowcase from '@fiverr-private/portfolio_showcase/src/PortfolioShowcase';
import SafePureComponent from '../shared/SafePureComponent';

import './index.scss';

const Portfolio = (props, context) => {

    const { isPageOwner, portfolio } = props;
    const { requestContext, pathfinderWrapper } = context;

    if (!portfolio) {
        return null;
    }

    const {
        username,
        slug
    } = requestContext.params;

    const {
        portfolioProjectsThumbs
    } = portfolio;

    if (!portfolioProjectsThumbs.length){
        return null;
    }

    const portfolioLink = pathfinderWrapper.pathfinder('user_portfolio_index',
        {user_id: username},
        {query: {
            gig: slug,
            origin: 'gig_page'
        }}
    );

    return (
        <PortfolioShowcase isPageOwner={isPageOwner}
            portfolioProjectsThumbs={portfolioProjectsThumbs}
            link={portfolioLink}/>
    );
};

Portfolio.propTypes = {
    isPageOwner: PropTypes.bool,
    portfolio: PropTypes.shape({
        portfolioProjectsThumbs: PropTypes.array
    })
};

Portfolio.contextTypes = {
    requestContext: PropTypes.object,
    pathfinderWrapper: PropTypes.object
};

export { Portfolio };
export default SafePureComponent(Portfolio);
